import { gql } from "@apollo/client";
export const WINE_DUPLICATE = gql `
  mutation WineDuplicate($input: WineDuplicateInput!) {
    WineDuplicate(input: $input)
  }
`;
